import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { ArrowLeft, Scale, Shield, Users } from 'lucide-react';

const LegalMentions = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header de navigation */}
      <Header />
      
      {/* Header de la page */}
      <div className="bg-gradient-to-r from-fsf-primary to-fsf-secondary text-white py-16">
        <div className="container mx-auto px-4">
          <Link 
            to="/" 
            className="inline-flex items-center space-x-2 text-white/80 hover:text-white transition-colors duration-200 mb-6"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Retour à l'accueil</span>
          </Link>
          
          <div className="flex items-center space-x-4">
            <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
              <Scale className="w-8 h-8 text-white" />
            </div>
            <div>
              <h1 className="text-4xl font-bold font-serif">Mentions légales</h1>
              <p className="text-xl text-white/80 mt-2">Informations légales et réglementaires</p>
            </div>
          </div>
        </div>
      </div>

      {/* Contenu */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          
          {/* Identification du site */}
          <section className="bg-white rounded-2xl shadow-lg p-8 mb-8">
            <div className="flex items-center space-x-3 mb-6">
              <Shield className="w-6 h-6 text-fsf-primary" />
              <h2 className="text-2xl font-bold text-gray-800">Identification du site</h2>
            </div>
            
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <h3 className="font-semibold text-gray-800 mb-3 text-left">Éditeur du site</h3>
                <div className="space-y-2 text-gray-600 text-left">
                  <p><strong>Nom :</strong> Communauté Fleurs de la Sainte Famille (FSF)</p>
                  <p><strong>Nature :</strong> Communauté chrétienne catholique</p>
                  <p><strong>Pays :</strong> République du Bénin</p>
                  <p><strong>Email :</strong> contact@fleursdelasaintefamille.org</p>
                </div>
              </div>
              
              <div>
                <h3 className="font-semibold text-gray-800 mb-3 text-left">Responsable de publication</h3>
                <div className="space-y-2 text-gray-600 text-left">
                  <p><strong>Publication :</strong> Noyau diocésain </p>
                  <p><strong>Email :</strong>contact@fleursdelasaintefamille.org</p>
                  <p><strong>Téléphone :</strong> +229 01 97 08 46 01</p>
                </div>
              </div>
            </div>
          </section>

          {/* Hébergement */}
          <section className="bg-white rounded-2xl shadow-lg p-8 mb-8 text-left">
            <div className="flex items-center space-x-3 mb-6">
              <Users className="w-6 h-6 text-fsf-primary" />
              <h2 className="text-2xl font-bold text-gray-800">Hébergement et technique</h2>
            </div>
            
            <div className="space-y-4 text-gray-600">
              <p>
                <strong>Développement :</strong> Le site web a été développé par l'équipe technique FSF 
                en utilisant des technologies modernes et respectueuses des standards web.
              </p>
              <p>
                <strong>Maintenance :</strong> La maintenance technique et les mises à jour sont 
                assurées par l'équipe informatique de la communauté FSF.
              </p>
            </div>
          </section>

          {/* Propriété intellectuelle */}
          <section className="bg-white rounded-2xl shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Propriété intellectuelle</h2>
            
            <div className="space-y-4 text-gray-600 text-justify">
              <p>
                L'ensemble de ce site relève de la législation béninoise et internationale sur le droit d'auteur 
                et la propriété intellectuelle. Tous les droits de reproduction sont réservés.
              </p>
              
              <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded text-justify">
                <h3 className="font-semibold text-blue-800 mb-2">Contenus protégés</h3>
                <ul className="list-disc list-inside space-y-1 text-blue-700">
                  <li>Textes, articles et méditations spirituelles</li>
                  <li>Photos et images de la communauté FSF</li>
                  <li>Logo et éléments graphiques</li>
                  <li>Structure et design du site web</li>
                </ul>
              </div>
              
              <p>
                <strong>Contenus religieux :</strong> Les textes liturgiques proviennent de l'AELF 
                (Communauté Épiscopale Liturgique pour les pays Francophones) et sont utilisés 
                conformément aux autorisations accordées.
              </p>
            </div>
          </section>

          {/* Utilisation du site */}
          <section className="bg-white rounded-2xl shadow-lg p-8 mb-8 text-justify">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Conditions d'utilisation</h2>
            
            <div className="space-y-4 text-gray-600 text-justify">
              <div>
                <h3 className="font-semibold text-gray-800 mb-2">Accès au site</h3>
                <p>
                  L'accès au site est gratuit et ouvert à tous. Certaines sections peuvent nécessiter 
                  une inscription pour les membres de la communauté FSF.
                </p>
              </div>
              
              <div>
                <h3 className="font-semibold text-gray-800 mb-2">Utilisation des contenus</h3>
                <p>
                  Les contenus spirituels et éducatifs peuvent être partagés à des fins non commerciales 
                  et dans un cadre de diffusion de la foi chrétienne, sous réserve de mention de la source.
                </p>
              </div>
              
              <div>
                <h3 className="font-semibold text-gray-800 mb-2">Responsabilité</h3>
                <p>
                  La communauté FSF s'efforce de maintenir des informations exactes mais ne peut garantir 
                  l'exhaustivité et l'exactitude de toutes les informations présentes sur le site.
                </p>
              </div>
            </div>
          </section>

          {/* Contact juridique */}
          <section className="bg-gradient-to-r from-fsf-primary to-fsf-secondary text-white rounded-2xl p-8">
            <h2 className="text-2xl font-bold mb-4">Contact pour questions ?</h2>
            
            <div className="space-y-3 text-justify">
              <p>
                Pour toute question concernant ces mentions légales ou l'utilisation du site :
              </p>
              <div className="space-y-2">
                <p><strong>Email :</strong> dpo@fleursdelasaintefamille.org</p>
                <p><strong>Courrier :</strong> Communauté FSF</p>
                <p className="text-sm text-white/80 mt-4">
                  Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default LegalMentions;